import { useNavigate } from "react-router-dom";

export default function CierreFiscal() {
  const navigate = useNavigate();
  return (
    <div style={{minHeight:"100vh",background:"#f3f4f6",padding:"2rem 1.5rem"}}>
      <div style={{maxWidth:"1400px",margin:"0 auto"}}>
        <button type="button" onClick={()=>navigate("/hacienda-presupuesto")}
          style={{background:"#e5e7eb",color:"#111827",border:"none",borderRadius:"10px",
            padding:"0.7rem 1rem",cursor:"pointer",fontWeight:600,marginBottom:"1.5rem"}}>
          ← Volver a Hacienda
        </button>
        <div style={{marginBottom:"1.5rem"}}>
          <h1 style={{margin:0,color:"#163b8c",fontSize:"2rem",fontWeight:800}}>
            Cierre Fiscal
          </h1>
          <p style={{marginTop:"0.5rem",color:"#6b7280"}}>Módulo en construcción</p>
        </div>
        <div style={{background:"#fff",borderRadius:"16px",border:"1px solid #e5e7eb",
          boxShadow:"0 4px 14px rgba(0,0,0,0.05)",padding:"4rem",textAlign:"center"}}>
          <div style={{fontSize:"3rem",marginBottom:"1rem"}}>🚧</div>
          <h2 style={{color:"#163b8c",fontWeight:800,marginBottom:"0.5rem"}}>
            Próximamente
          </h2>
          <p style={{color:"#6b7280",maxWidth:"480px",margin:"0 auto"}}>
            El módulo de Cierre Fiscal está en desarrollo. Aquí se gestionará el cierre
            de la vigencia presupuestal con sus respectivos registros y validaciones.
          </p>
        </div>
      </div>
    </div>
  );
}